module.exports = __webpack_public_path__ + "static/media/on_three.75258d59.png";